// src/pages/auth/SignupPage.jsx
import React from 'react';
import AuthLayout from "@layouts/AuthLayout";
import { SignUpForm } from '@/components/forms/SignUpForm';

const SignUpPage = () => (
  <AuthLayout heading="Create Account">
  <SignUpForm />
</AuthLayout>
);

export default SignUpPage;
